import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from '@/components/ui/separator';
import PageMeta from '@/components/SEO/PageMeta';

const Confidentialite = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta 
        title="Confidentialité La Patrimoniale - Protection des Données et RGPD"
        description="Découvrez la politique de confidentialité de La Patrimoniale, cabinet expert en gestion de patrimoine à Paris : traitement et sécurisation de vos données personnelles, engagement RGPD, respect de la vie privée, transparence sur l'utilisation des informations transmises. La Patrimoniale veille à la sécurité et la confidentialité des données de tous ses clients et de leurs patrimoines."
        keywords="La Patrimoniale, politique confidentialité, protection des données, RGPD, gestion patrimoine sécurisé, sécurité données personnelles, confidentialité patrimoine, vie privée cabinet La Patrimoniale, patrimoine Paris"
        canonical="https://www.la-patrimoniale-gestion.com/confidentialite"
      />
      <Navbar />
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-4 md:px-6">
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-patrimoine-dark mb-8">Politique de Confidentialité</h1>
          
          <Separator className="mb-8" />
          
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Introduction</h2>
              <p className="text-gray-700 leading-relaxed">
                LA PATRIMONIALE (« nous », « notre », « nos ») s'engage à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons, divulguons, conservons et protégeons vos informations personnelles.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Informations que nous collectons</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Nous pouvons collecter les types d'informations suivants :
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-700">
                <li>Informations d'identification (nom, prénom, adresse postale, email, téléphone)</li>
                <li>Informations financières (revenus, patrimoine, investissements)</li>
                <li>Informations relatives à votre situation professionnelle et familiale</li>
                <li>Informations techniques (adresse IP, données de navigation)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Utilisation de vos informations</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Nous utilisons vos informations personnelles pour :
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-700">
                <li>Fournir, personnaliser et améliorer nos services</li>
                <li>Établir un diagnostic patrimonial et financier adapté à votre situation</li>
                <li>Respecter nos obligations légales et réglementaires</li>
                <li>Vous informer sur nos services et actualités</li>
                <li>Répondre à vos questions et demandes</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Conservation des données</h2>
              <p className="text-gray-700 leading-relaxed">
                Nous conservons vos données personnelles aussi longtemps que nécessaire pour atteindre les objectifs décrits dans cette politique de confidentialité, sauf si une période de conservation plus longue est requise ou permise par la loi.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Vos droits</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Conformément à la réglementation applicable, vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-700">
                <li>Droit d'accès à vos données personnelles</li>
                <li>Droit de rectification de vos données personnelles</li>
                <li>Droit d'effacement de vos données personnelles</li>
                <li>Droit à la limitation du traitement de vos données personnelles</li>
                <li>Droit d'opposition au traitement de vos données personnelles</li>
                <li>Droit à la portabilité de vos données personnelles</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Contact</h2>
              <p className="text-gray-700 leading-relaxed">
                Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, veuillez nous contacter à l'adresse suivante : 47 BOULEVARD DE BEAUSEJOUR, 75016 PARIS ou par email à contact@la-patrimoniale-gestion.com.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Confidentialite;
